/* __next_internal_client_entry_do_not_use__ TooltipProvider,Tooltip auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixTooltip from "@radix-ui/react-tooltip";
export const TooltipProvider = RadixTooltip.Provider;
export const Tooltip = (param)=>{
    let { align, alignOffset, avoidCollisions, children, className, "data-testid": testId, defaultOpen, delayDuration = 500, disableHoverableContent = false, label, onOpenChange, open, side, sideOffset = 8 } = param;
    if (!label) return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
    return /*#__PURE__*/ _jsxs(RadixTooltip.Root, {
        defaultOpen: defaultOpen,
        delayDuration: delayDuration,
        disableHoverableContent: disableHoverableContent,
        onOpenChange: onOpenChange,
        open: open,
        children: [
            /*#__PURE__*/ _jsx(RadixTooltip.Trigger, {
                asChild: true,
                children: children
            }),
            /*#__PURE__*/ _jsx(RadixTooltip.Portal, {
                children: /*#__PURE__*/ _jsxs(RadixTooltip.Content, {
                    align: align,
                    alignOffset: alignOffset,
                    avoidCollisions: avoidCollisions,
                    className: tailwindMerge("z-10 min-h-[32px] rounded bg-black px-2 py-1.5 text-14 font-medium text-white", className),
                    "data-testid": testId,
                    side: side,
                    sideOffset: sideOffset,
                    children: [
                        label,
                        /*#__PURE__*/ _jsx(RadixTooltip.Arrow, {})
                    ]
                })
            })
        ]
    });
};
